import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { Document } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

interface Props extends StyleProps {
	document?: Document
	content?: Array<ReactNode>
}

interface StyleProps {
	maxWidth?: number
}

export const RichTextArea = ({ document, maxWidth, content }: Props): JSX.Element => {
	const nodes = document ? documentToReactComponents(document) : content

	return <RichTextAreaWrapper maxWidth={maxWidth}>{nodes}</RichTextAreaWrapper>
}

const RichTextAreaWrapper = styled.div<StyleProps>`
	${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}px;`}
	h2, p {
		margin-bottom: 24px;
	}
	ul,
	ol {
		padding-left: 24px;
	}
`
